import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import { action } from '@ember/object';
import Transition from '@ember/routing/-private/transition';
import ImportModel, { ImportState } from 'cio/models/import';
import DS from 'ember-data';

export default class ImportRoute extends Route {
  @service store!: DS.Store;

  crumb() {
    let model = this.modelFor(this.routeName) as ImportModel;

    return {
      name: model.name || model.filename,
      path: this.routeName,
      model,
    };
  }

  model(params: Record<string, any>) {
    return this.store.findRecord('import', params.import_id);
  }

  // Because of the way crumbs work, they need to be static and can't update. When an
  // import changes fro, being setup to being a finalized import, the crumb for
  // imports.import (this route) doesn't get updated. This will intercept a click on the
  // crumb from any setup route so that instead of going to imports.import.index for an
  // incomplete import, it goes to imports.import.setup instead so that the use can
  // finish the setup.
  @action
  willTransition(transition: Transition) {
    let model = this.modelFor(this.routeName) as ImportModel;

    if (model.state !== ImportState.Imported && transition.to.name === 'imports.import.index') {
      return this.router.transitionTo('imports.import.setup', model.id);
    }

    return;
  }

  redirect(model: ImportModel, transition: Transition) {
    let { state } = model;

    let STATE_ROUTES: Partial<Record<ImportState, string>> = {
      [ImportState.Imported]: 'index',
      [ImportState.Failed]: 'setup.index',
      [ImportState.Preprocessing]: 'setup.preprocessing',
      [ImportState.Validating]: 'setup.validating',
      [ImportState.Importing]: 'setup.importing',
      [ImportState.Validated]: 'setup.review',
    };

    if (STATE_ROUTES[state] != null) {
      return this.router.transitionTo(`imports.import.${STATE_ROUTES[state]}`, model);
    }

    let route = model.isEventsImport ? 'imports.import.setup.preview' : 'imports.import.setup.fields';

    if (state === ImportState.Preprocessed) {
      let childRoutes = ['imports.import.setup.attributes', route, 'imports.import.setup.review'];

      if (childRoutes.includes(transition.to.name)) {
        return;
      }

      return this.router.transitionTo(route, model);
    }

    return this.router.transitionTo('imports.import.setup.index', model);
  }

  @action
  refreshCrumb() {
    (this as any).reloadCrumb();
  }
}
